// extracted by mini-css-extract-plugin
module.exports = {"awaiting":"StatusBadge_awaiting__NLxEy","completed":"StatusBadge_completed__DFeQj"};